import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import gatewayPagesRoleManagement from '../../staticRoleManagement/gatewayRoleManagement'
import useStyles from './styles/GatewayFooter.styles'

interface GatewayFooterProps {
  loadingForSubmit: boolean
}

export const GatewayFooter: React.FC<GatewayFooterProps> = ({
  loadingForSubmit
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const hasAccessToSaveGateway = gatewayPagesRoleManagement
    .find((item) => item.route === '/gateway/create')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  const hasAccessToModifyGateway = gatewayPagesRoleManagement
    .find((item) => item.route === '/gateway/:id/details')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.footer}>
      <Button
        disabled={
          !hasAccessToSaveGateway ||
          !hasAccessToModifyGateway ||
          loadingForSubmit
        }
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        fullWidth={matches}>
        {getTranslate('Save Gateway')}
        {loadingForSubmit && (
          <CircularProgress
            className={classes.circularProgress}
            size={16}
            color="primary"
          />
        )}
      </Button>
    </div>
  )
}
export default GatewayFooter
